import { render, staticRenderFns } from "./InsuranceUploadForm.vue?vue&type=template&id=9519cc4c&scoped=true&"
import script from "./InsuranceUploadForm.vue?vue&type=script&lang=ts&"
export * from "./InsuranceUploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceUploadForm.vue?vue&type=style&index=0&id=9519cc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9519cc4c",
  null
  
)

export default component.exports